export const termsAndConditions = `
# Adatvédelmi nyilatkozat

A Red-Rel Kft. (1165 Budapest, Légcsavar utca 5. adószám: 11845166-2-42) (a továbbiakban: Szolgáltató, adatkezelő) alá veti magát a következő tájékoztatónak.

A természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről (általános adatvédelmi rendelet) AZ EURÓPAI PARLAMENT ÉS A TANÁCS (EU) 2016/679 RENDELETE (2016. április 27.) szerint az alábbi tájékoztatást adjuk.

Jelen adatkezelési tájékoztató az alábbi oldalak adatkezelését szabályozza: www.arnyekbolt.hu

Az adatkezelési tájékoztató elérhető az alábbi oldalról: https://www.arnyekbolt.hu/adatvedelmi-nyilatkozat/

A tájékoztató módosításai a fenti címen történő közzététellel lépnek hatályba.

---

## Adatkezelő adatai

**Red-Rel Kft.**  
Levelezési cím: 1165 Budapest, Légcsavar utca 5.  
Telefon: +36 70 308 0787  
E-mail: info@arnyekbolt.hu

---

## FOGALOM MEGHATÁROZÁSOK

1. **„személyes adat"**: azonosított vagy azonosítható természetes személyre („érintett") vonatkozó bármely információ; azonosítható az a természetes személy, aki közvetlen vagy közvetett módon, különösen valamely azonosító, például név, szám, helymeghatározó adat, online azonosító vagy a természetes személy testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező alapján azonosítható;

2. **„adatkezelés"**: a személyes adatokon vagy adatállományokon automatizált vagy nem automatizált módon végzett bármely művelet vagy műveletek összessége, így a gyűjtés, rögzítés, rendszerezés, tagolás, tárolás, átalakítás vagy megváltoztatás, lekérdezés, betekintés, felhasználás, közlés továbbítás, terjesztés vagy egyéb módon történő hozzáférhetővé tétel útján, összehangolás vagy összekapcsolás, korlátozás, törlés, illetve megsemmisítés;

3. **„adatkezelő"**: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely a személyes adatok kezelésének céljait és eszközeit önállóan vagy másokkal együtt meghatározza; ha az adatkezelés céljait és eszközeit az uniós vagy a tagállami jog határozza meg, az adatkezelőt vagy az adatkezelő kijelölésére vonatkozó különös szempontokat az uniós vagy a tagállami jog is meghatározhatja;

4. **„adatfeldolgozó"**: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely az adatkezelő nevében személyes adatokat kezel;

5. **„címzett"**: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, akivel vagy amellyel a személyes adatot közlik, függetlenül attól, hogy harmadik fél-e. Azon közhatalmi szervek, amelyek egy egyedi vizsgálat keretében az uniós vagy a tagállami joggal összhangban férhetnek hozzá személyes adatokhoz, nem minősülnek címzettnek; az említett adatok e közhatalmi szervek általi kezelése meg kell, hogy feleljen az adatkezelés céljainak megfelelően az alkalmazandó adatvédelmi szabályoknak;

6. **„az érintett hozzájárulása"**: az érintett akaratának önkéntes, konkrét és megfelelő tájékoztatáson alapuló és egyértelmű kinyilvánítása, amellyel az érintett nyilatkozat vagy a megerősítést félreérthetetlenül kifejező cselekedet útján jelzi, hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez;

7. **„adatvédelmi incidens"**: a biztonság olyan sérülése, amely a továbbított, tárolt vagy más módon kezelt személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését, megváltoztatását, jogosulatlan közlését vagy az azokhoz való jogosulatlan hozzáférést eredményezi.

---

## A SZEMÉLYES ADATOK KEZELÉSÉRE VONATKOZÓ ELVEK

A személyes adatok:

**a)** kezelését jogszerűen és tisztességesen, valamint az érintett számára átlátható módon kell végezni („jogszerűség, tisztességes eljárás és átláthatóság");

**b)** gyűjtése csak meghatározott, egyértelmű és jogszerű célból történjen, és azokat ne kezeljék ezekkel a célokkal össze nem egyeztethető módon; a 89. cikk (1) bekezdésének megfelelően nem minősül az eredeti céllal össze nem egyeztethetőnek a közérdekű archiválás céljából, tudományos és történelmi kutatási célból vagy statisztikai célból történő további adatkezelés („célhoz kötöttség");

**c)** az adatkezelés céljai szempontjából megfelelőek és relevánsak kell, hogy legyenek, és a szükségesre kell korlátozódniuk („adattakarékosság");

**d)** pontosnak és szükség esetén naprakésznek kell lenniük; minden észszerű intézkedést meg kell tenni annak érdekében, hogy az adatkezelés céljai szempontjából pontatlan személyes adatokat haladéktalanul töröljék vagy helyesbítsék („pontosság");

**e)** tárolásának olyan formában kell történnie, amely az érintettek azonosítását csak a személyes adatok kezelése céljainak eléréséhez szükséges ideig teszi lehetővé („korlátozott tárolhatóság");

**f)** kezelését oly módon kell végezni, hogy megfelelő technikai vagy szervezési intézkedések alkalmazásával biztosítva legyen a személyes adatok megfelelő biztonsága, az adatok jogosulatlan vagy jogellenes kezelésével, véletlen elvesztésével, megsemmisítésével vagy károsodásával szembeni védelmet is ideértve („integritás és bizalmas jelleg").

Az adatkezelő felelős a fentiek megfelelésért, továbbá képesnek kell lennie e megfelelés igazolására („elszámoltathatóság").

---

## ADATKEZELÉSEK

### WEBÁRUHÁZ MŰKÖDTETÉSHEZ KAPCSOLÓDÓ ADATKEZELÉS

**1. Az adatgyűjtés ténye, a kezelt adatok köre és az adatkezelés célja:**

| Személyes adat | Az adatkezelés célja |
|----------------|----------------------|
| Jelszó | A felhasználói fiókba történő biztonságos belépést szolgálja. |
| Vezeték-és keresztnév | A kapcsolatfelvételhez, a vásárláshoz és a szabályszerű számla kiállításához szükséges. |
| E-mail cím | Kapcsolattartás |
| Telefonszám | Kapcsolattartás, a számlázással, vagy a szállítással kapcsolatos kérdések hatékonyabb egyeztetése. |
| Számlázási név, cím | A szabályszerű számla kiállítása, továbbá a szerződés létrehozása, tartalmának meghatározása, módosítása, teljesítésének figyelemmel kísérése. |
| Szállítási név és cím | A házhoz szállítás lehetővé tétele. |
| A vásárlás/regisztráció időpontja | Technikai művelet végrehajtása. |
| A vásárlás/regisztráció kori IP cím | Technikai művelet végrehajtása. |

*Az e-mail cím esetében nem szükséges, hogy személyes adatot tartalmazzon.*

**2. Az érintettek köre:**  
A webshop weboldalon regisztrált/vásárló valamennyi érintett.

**3. Az adatkezelés időtartama, az adatok törlésének határideje:**  
A regisztráció törlésével azonnal. Kivéve a számviteli bizonylatok esetében, hiszen a számvitelről szóló 2000. évi C. törvény 169. § (2) bekezdése alapján 8 évig meg kell őrizni ezeket az adatokat.

A könyvviteli elszámolást közvetlenül és közvetetten alátámasztó számviteli bizonylatot (ideértve a főkönyvi számlákat, az analitikus, illetve részletező nyilvántartásokat is), legalább 8 évig kell olvasható formában, a könyvelési feljegyzések hivatkozása alapján visszakereshető módon megőrizni.

**4. Az adatok megismerésére jogosult lehetséges adatkezelők személye:**  
A személyes adatokat az adatkezelő sales és marketing munkatársai kezelhetik, a fenti alapelvek tiszteletben tartásával.

**5. Az érintettek adatkezeléssel kapcsolatos jogai:**
- Az érintett kérelmezheti az adatkezelőtől a rá vonatkozó személyes adatokhoz való hozzáférést, azok helyesbítését, törlését vagy kezelésének korlátozását
- Tiltakozhat az ilyen személyes adatok kezelése ellen
- Az érintettnek joga van az adathordozhatósághoz, továbbá a hozzájárulás bármely időpontban történő visszavonásához

**6. Kapcsolatfelvétel:**
- Postai cím: 1165 Budapest, Légcsavar utca 5.
- E-mail: info@arnyekbolt.hu
- Telefon: +36 70 308 0787

**7. Az adatkezelés jogalapja:**
- 7.1. Az érintett hozzájárulása, 6. cikk (1) bekezdés a) pont, az Infotv. 5. § (1) bekezdése
- 7.2. Az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről szóló 2001. évi CVIII. törvény 13/A. § (3) bekezdése
- 7.3. A számviteli jogszabályoknak megfelelő számlát kiállítása esetén a 6. cikk (1) bekezdés c) pontja

**8. Tájékoztatás:**
- Az adatkezelés az Ön hozzájárulásán alapul
- Köteles a személyes adatokat megadni, hogy tudjuk a rendelését teljesíteni
- Az adatszolgáltatás elmaradása azzal a következményekkel jár, hogy nem tudjuk a rendelését feldolgozni

---

### AZ IGÉNYBE VETT ADATFELDOLGOZÓK

#### Futárszolgálat

**GLS General Logistics Systems Hungary Kft.**  
2351 Alsónémedi, Európa u. 2.  
info@gls-hungary.com  
Telefon: +36 1 802 0265  
https://gls-group.eu/HU/hu/adatvedelmi-szabalyzat

**Kezelt adatok:** Szállítási név, szállítási cím, telefonszám, e-mail cím  
**Érintettek köre:** A házhozszállítást kérő valamennyi érintett  
**Adatkezelés célja:** A megrendelt termék házhoz szállítása  
**Adatkezelés időtartama:** A házhozszállítás lebonyolításáig  
**Jogalap:** A Felhasználó hozzájárulása, 6. cikk (1) bekezdés a) pontja

#### Tárhelyszolgáltató

**Webonic Kft.**  
8000 Székesfehérvár, Budai út 9-11.  
Telefon: +36-22-78-76-74  
E-mail: support@webonic.hu

**Kezelt adatok:** Az érintett által megadott valamennyi személyes adat  
**Érintettek köre:** A weboldalt használó valamennyi érintett  
**Adatkezelés célja:** A weboldal elérhetővé tétele, megfelelő működtetése  
**Adatkezelés időtartama:** Az adatkezelő és a tárhely-szolgáltató közötti megállapodás megszűnéséig

#### Online fizetés szolgáltatója

**Barion Payment Zrt.**  
1117 Budapest, Irinyi József utca 4-20. 2 em.  
Cégjegyzékszám: 01 10 048552  
Adószám: 25353192243

#### Számlavezető bank

**ERSTE BANK HUNGARY ZRT.**  
1138 Budapest, Népfürdő utca 24-26.  
Cégjegyzékszám: 01 10 041054  
Adószám: 10197879444

#### Hírlevélküldő

**Amega Full Service Kft.**  
1114 Budapest, Ulászló u. 9.  
Cégjegyzékszám: 01 09 931248  
Adószám: 11713373243

#### Számlázás

**KBOSS.hu Kft**  
1031 Budapest, Záhony utca 7.  
Cégjegyzékszám: 01 09 303201  
Adószám: 13421739241

#### Könyvelés

**„AG.MAMAS" Kft.**  
1133 Budapest, Árbóc utca 6. 2.em.  
Cégjegyzékszám: 01 09 958722  
Adószám: 13992154241

#### Hirdetéskezelők

**Google Számítástechnikai Szolgáltató Kft.**  
1023 Budapest, Árpád fejedelem útja 26-28.  
Cégjegyzékszám: 01 09 861726  
Adószám: 13561677241

**Facebook Ireland Limited**  
Address: 4 Grand Canal Square, Dublin, Ireland  
Company Registration Number: 462932  
Contact phone number: +353 1 5530588

---

## COOKIE-K (SÜTIK) KEZELÉSE

1. Webáruházakra jellemző cookie-k az úgynevezett „jelszóval védett munkamenethez használt cookie", „bevásárlókosárhoz szükséges cookie-k" és „biztonsági cookie-k", melyek használatához nem szükséges előzetes hozzájárulást kérni az érintettektől.

2. **Kezelt adatok köre:** Egyedi azonosítószám, dátumok, időpontok

3. **Érintettek köre:** A weboldalt látogató valamennyi érintett

4. **Adatkezelés célja:** A felhasználók azonosítása, a „bevásárlókosár" nyilvántartására és a látogatók nyomon követése

5. **Adatkezelés időtartama:**

| Süti típusa | Adatkezelés jogalapja | Adatkezelés időtartama | Kezelt adatkör |
|-------------|----------------------|------------------------|----------------|
| Munkamenet sütik (session) | 2001. CVIII. törvény 13/A § (3) bekezdése | A látogatói munkamenet lezárásáig | connect.sid |

Más esetekben az adatkezelés időtartama maximum 30 napig tart.

6. Az érintettnek lehetőségük van a cookie-kat törölni a böngészők Eszközök/Beállítások menüjében általában az Adatvédelem menüpont beállításai alatt.

---

## GOOGLE ADS KONVERZIÓKÖVETÉS HASZNÁLATA

1. A „Google Ads" nevű online reklámprogramot használja az adatkezelő, továbbá annak keretein belül igénybe veszi a Google konverziókövető szolgáltatását. A Google konverziókövetés a Google Inc. elemző szolgáltatása (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA).

2. Amikor Felhasználó egy weboldalt Google-hirdetés által ér el, akkor egy a konverziókövetéshez szükséges cookie kerül a számítógépére. Ezeknek a cookie-knak az érvényessége korlátozott, és nem tartalmaznak semmilyen személyes adatot.

3. Az információk – melyeket a konverziókövető cookie-k segítségével szereztek – azt a célt szolgálják, hogy az Ads konverziókövetést választó ügyfeleinek számára konverziós statisztikákat készítsenek.

4. Ha nem szeretne részt venni a konverziókövetésben, akkor ezt elutasíthatja azáltal, hogy böngészőjében letiltja a cookie-k telepítésének lehetőségét.

5. További információ: www.google.de/policies/privacy/

---

## A GOOGLE ANALYTICS ALKALMAZÁSA

1. Ez a honlap a Google Analytics alkalmazást használja, amely a Google Inc. („Google") webelemző szolgáltatása. A Google Analytics úgynevezett „cookie-kat", szövegfájlokat használ.

2. A Felhasználó által használt weboldallal kapcsolatos cookie-kkal létrehozott információk rendszerint a Google egyik USA-beli szerverére kerülnek és tárolódnak. Az IP-anonimizálás weboldali aktiválásával a Google a Felhasználó IP-címét az Európai Unió tagállamain belül előzőleg megrövidíti.

3. A Google Analytics keretén belül a Felhasználó böngészője által továbbított IP-címet nem vezeti össze a Google más adataival.

4. Megakadályozhatja a Google adatgyűjtését, ha letölti és telepíti a következő böngésző plugint: https://tools.google.com/dlpage/gaoptout?hl=hu

---

## HÍRLEVÉL, DM TEVÉKENYSÉG

1. A gazdasági reklámtevékenység alapvető feltételeiről és egyes korlátairól szóló 2008. évi XLVIII. törvény 6. §-a értelmében Felhasználó előzetesen és kifejezetten hozzájárulhat ahhoz, hogy Szolgáltató reklámajánlataival megkeresse.

2. Szolgáltató nem küld kéretlen reklámüzenetet, és Felhasználó korlátozás és indokolás nélkül, ingyenesen leiratkozhat az ajánlatok küldéséről.

**Kezelt adatok:**

| Személyes adat | Az adatkezelés célja |
|----------------|----------------------|
| Név, e-mail cím | Azonosítás, a hírlevélre való feliratkozás lehetővé tétele |
| A feliratkozás időpontja | Technikai művelet végrehajtása |
| A feliratkozás kori IP cím | Technikai művelet végrehajtása |

**Érintettek köre:** A hírlevélre feliratkozó valamennyi érintett

**Adatkezelés célja:** Reklámot tartalmazó elektronikus üzenetek (e-mail, sms, push üzenet) küldése

**Adatkezelés időtartama:** A leiratkozásig

**Nyilvántartási szám:** NAIH-131920/2017

**Adatfeldolgozó:**  
Amega Full Service Kft  
Szolgáltatás: Hírlevélküldő rendszer  
Székhely: Ulászló utca 9. Bp. 1114  
Telefon: (+36) 1 215 4454

---

## PANASZKEZELÉS

**Kezelt adatok:**

| Személyes adat | Az adatkezelés célja |
|----------------|----------------------|
| Vezeték- és keresztnév | Azonosítás, kapcsolattartás |
| E-mail cím | Kapcsolattartás |
| Telefonszám | Kapcsolattartás |
| Számlázási név, cím | A megrendelt termékekkel kapcsolatos minőségi kifogások kezelése |

**Érintettek köre:** A webshop weboldalon vásárló és panaszt tevő valamennyi érintett

**Adatkezelés időtartama:** A fogyasztóvédelemről szóló 1997. évi CLV. törvény 17/A. § (7) bekezdése alapján 5 évig

**Kapcsolatfelvétel:**
- Postai cím: 1165 Budapest, Légcsavar utca 5.
- E-mail: info@arnyekbolt.hu
- Telefon: +36 70 308 0787

---

## KÖZÖSSÉGI OLDALAK

1. **Kezelt adatok:** Facebook/Instagram/Pinterest/Youtube stb. közösségi oldalakon regisztrált neve, illetve a felhasználó nyilvános profilképe

2. **Érintettek köre:** Valamennyi érintett, aki regisztrált a közösségi oldalakon, és „lájkolta" a weboldalt

3. **Adatgyűjtés célja:** A weboldal egyes tartalmi elemeinek, termékeinek, akcióinak megosztása, illetve „lájkolása", népszerűsítése

4. Az adatkezelés a közösségi oldalakon valósul meg, így az adatkezelés időtartamára, módjára az adott közösségi oldal szabályozása vonatkozik

---

## ÜGYFÉLKAPCSOLATOK ÉS EGYÉB ADATKEZELÉSEK

1. Amennyiben az adatkezelő szolgáltatásaink igénybevétele során kérdés merülne fel, a honlapon megadott módokon (telefon, email, közösségi oldalak stb.) kapcsolatba léphet az adatkezelővel.

2. Adatkezelő a beérkezett e-maileket, üzeneteket, telefonon, Facebook-on stb. megadott adatokat az érdeklődő nevével és e-mail címével, valamint más, önként megadott személyes adatával együtt, az adatközléstől számított legfeljebb 2 év elteltével törli.

3. Kivételes hatósági megkeresésre, illetőleg jogszabály felhatalmazása alapján más szervek megkeresése esetén a Szolgáltató köteles tájékoztatás adására, adatok közlésére, átadására.

---

## AZ ÉRINTETTEK JOGAI

### 1. A hozzáférés joga
Ön jogosult arra, hogy az adatkezelőtől visszajelzést kapjon arra vonatkozóan, hogy személyes adatainak kezelése folyamatban van-e, és ha ilyen adatkezelés folyamatban van, jogosult arra, hogy a személyes adatokhoz és a rendeletben felsorolt információkhoz hozzáférést kapjon.

### 2. A helyesbítéshez való jog
Ön jogosult arra, hogy kérésére az adatkezelő indokolatlan késedelem nélkül helyesbítse a rá vonatkozó pontatlan személyes adatokat.

### 3. A törléshez való jog
Ön jogosult arra, hogy kérésére az adatkezelő indokolatlan késedelem nélkül törölje a rá vonatkozó személyes adatokat.

### 4. Az elfeledtetéshez való jog
Ha az adatkezelő nyilvánosságra hozta a személyes adatot, és azt törölni köteles, az elérhető technológia és a megvalósítás költségeinek figyelembevételével megteszi az ésszerűen elvárható lépéseket.

### 5. Az adatkezelés korlátozásához való jog
Ön jogosult arra, hogy kérésére az adatkezelő korlátozza az adatkezelést, ha az alábbi feltételek valamelyike teljesül:
- Ön vitatja a személyes adatok pontosságát
- Az adatkezelés jogellenes, és Ön ellenzi az adatok törlését
- Az adatkezelőnek már nincs szüksége a személyes adatokra, de Ön igényli azokat jogi igények érvényesítéséhez
- Ön tiltakozott az adatkezelés ellen

### 6. Az adathordozhatósághoz való jog
Ön jogosult arra, hogy a rá vonatkozó, általa egy adatkezelő rendelkezésére bocsátott személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja.

### 7. A tiltakozáshoz való jog
Ön jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak a kezelése ellen.

### 8. Tiltakozás közvetlen üzletszerzés esetén
Ha a személyes adatok kezelése közvetlen üzletszerzés érdekében történik, Ön jogosult arra, hogy bármikor tiltakozzon a rá vonatkozó személyes adatok e célból történő kezelése ellen.

### 9. Automatizált döntéshozatal egyedi ügyekben
Ön jogosult arra, hogy ne terjedjen ki rá az olyan, kizárólag automatizált adatkezelésen alapuló döntés hatálya, amely rá nézve joghatással járna.

---

## INTÉZKEDÉSI HATÁRIDŐ

Az adatkezelő indokolatlan késedelem nélkül, de mindenféleképpen a kérelem beérkezésétől számított **1 hónapon belül** tájékoztatja Önt a fenti kérelmek nyomán hozott intézkedésekről.

Szükség esetén ez **2 hónappal meghosszabbítható**. A határidő meghosszabbításáról az adatkezelő a késedelem okainak megjelölésével a kérelem kézhezvételétől számított 1 hónapon belül tájékoztatja Önt.

---

## AZ ADATKEZELÉS BIZTONSÁGA

Az adatkezelő és az adatfeldolgozó a tudomány és technológia állása és a megvalósítás költségei, továbbá az adatkezelés jellege, hatóköre, körülményei és céljai, valamint a természetes személyek jogaira és szabadságaira jelentett kockázat figyelembevételével megfelelő technikai és szervezési intézkedéseket hajt végre, ideértve:

a) a személyes adatok álnevesítését és titkosítását;  
b) a személyes adatok kezelésére használt rendszerek és szolgáltatások folyamatos bizalmas jellegének biztosítását;  
c) fizikai vagy műszaki incidens esetén az arra való képességet, hogy a személyes adatokhoz való hozzáférést kellő időben vissza lehet állítani;  
d) az adatkezelés biztonságának garantálására hozott intézkedések hatékonyságának rendszeres tesztelésére szolgáló eljárást.

---

## AZ ÉRINTETT TÁJÉKOZTATÁSA AZ ADATVÉDELMI INCIDENSRŐL

Ha az adatvédelmi incidens valószínűsíthetően magas kockázattal jár a természetes személyek jogaira és szabadságaira nézve, az adatkezelő indokolatlan késedelem nélkül tájékoztatja az érintettet az adatvédelmi incidensről.

**Az érintettet nem kell tájékoztatni, ha:**
- Az adatkezelő megfelelő technikai és szervezési védelmi intézkedéseket hajtott végre (pl. titkosítás)
- Az adatkezelő olyan további intézkedéseket tett, amelyek biztosítják, hogy a magas kockázat nem valósul meg
- A tájékoztatás aránytalan erőfeszítést tenne szükségessé

---

## ADATVÉDELMI INCIDENS BEJELENTÉSE A HATÓSÁGNAK

Az adatvédelmi incidenst az adatkezelő indokolatlan késedelem nélkül, és ha lehetséges, legkésőbb **72 órával** azután, hogy az adatvédelmi incidens a tudomására jutott, bejelenti az illetékes felügyeleti hatóságnak, kivéve, ha az adatvédelmi incidens valószínűsíthetően nem jár kockázattal a természetes személyek jogaira és szabadságaira nézve.

---

## PANASZTÉTELI LEHETŐSÉG

Az adatkezelő esetleges jogsértése ellen panasszal a Nemzeti Adatvédelmi és Információszabadság Hatóságnál lehet élni:

**Nemzeti Adatvédelmi és Információszabadság Hatóság**  
1125 Budapest, Szilágyi Erzsébet fasor 22/C.  
Levelezési cím: 1530 Budapest, Postafiók: 5.  
Telefon: +36-1-391-1400  
Fax: +36-1-391-1410  
E-mail: ugyfelszolgalat@naih.hu

---

## ZÁRSZÓ

A tájékoztató elkészítése során figyelemmel voltunk az alábbi jogszabályokra:

- **EU 2016/679 rendelet** – általános adatvédelmi rendelet (GDPR) (2016. április 27.)
- **2011. évi CXII. törvény** – az információs önrendelkezési jogról és az információszabadságról (Infotv.)
- **2001. évi CVIII. törvény** – az elektronikus kereskedelmi szolgáltatásokról
- **2008. évi XLVII. törvény** – a fogyasztókkal szembeni tisztességtelen kereskedelmi gyakorlat tilalmáról
- **2008. évi XLVIII. törvény** – a gazdasági reklámtevékenység alapvető feltételeiről
- **2001. évi XC. törvény** – az elektronikus információszabadságról
- **2001. évi C. törvény** – az elektronikus hírközlésről
- **16/2011. sz. vélemény** a viselkedésalapú online reklám bevált gyakorlatára vonatkozó EASA/IAB-ajánlásról

---

**Utolsó frissítés:** 2025. október 27.
`

export default termsAndConditions